import React, { memo } from 'react';
import { Box, LinkButton } from '@common-fe/common-fe';

interface LoadMoreButtonProps {
  isExpanded: boolean;
  remainingCount: number;
  onClick: () => void;
  isPending?: boolean;
}

export const LoadMoreButton = memo<LoadMoreButtonProps>(
  ({ isExpanded, remainingCount, onClick, isPending = false }) => {
    const buttonText = isExpanded ? 'Show Less' : `Show More (${remainingCount})`;

    return (
      <Box align="center">
        <LinkButton
          onClick={onClick}
          disabled={isPending}
          aria-expanded={isExpanded}
          aria-label={buttonText}
          linkInlineMode
        >
          {buttonText}
        </LinkButton>
      </Box>
    );
  }
);

LoadMoreButton.displayName = 'LoadMoreButton';
